import { Component, OnInit, Optional, Self, ChangeDetectionStrategy, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { FieldConventionService, ValidationMessageService } from 'src/app/stp/stp-app/forms';
import { BaseInputComponent } from '../base-input';

@Component({
  selector: 'stp-input',
  templateUrl: './input.component.html'
})
export class InputComponent extends BaseInputComponent implements OnInit {

  @Input() maxLength = 255;

  constructor(@Optional() @Self() ngControl: NgControl,
    fieldConventionService: FieldConventionService,
    validationMessageService: ValidationMessageService) {
    super(ngControl, fieldConventionService, validationMessageService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
